/**
 * 내(로컬) 미디어 연결/송출 건강 상태 갱신.
 * {
 *     type: SET_MEDIA_HEALTH,
 *     state: 'ok' | 'interrupted' | 'signaling' | 'no-data' | 'recovering' | 'failed',
 *     reason?: string,
 *     since?: number
 * }
 */
export const SET_MEDIA_HEALTH = 'SET_MEDIA_HEALTH';
